import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../app/Locale';
import AuthenticationModal from '../../app2/store/components/AuthenticationModal';
import Message from '../../app2/ComponentMessage';
const TYPE_SAVE = 'save';
const TYPE_EXIT = 'exit';
const LawdocsSaveButton = ({ user }) => {
    const [isLoading, setLoading] = useState(false);
    const [isAuthenticationModalVisible, setAuthenticationModalVisible] = useState(false);
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    /**
     * Save the Lawdocs document.
     *
     * @param {string} type
     * @param {boolean} forceSave
     */
    const save = (type, forceSave = false) => {
        const { LawDocs, ga, location } = window;
        if (!user && !isAuthenticated && !forceSave) {
            setAuthenticationModalVisible(true);
            return;
        }
        if (type === TYPE_SAVE) {
            setAuthenticationModalVisible(false);
        }
        if (isLoading) {
            return;
        }
        setErrorMessage(false);
        setAuthenticated(true);
        setLoading(type);
        LawDocs.addSetting('is_authenticated', true);
        LawDocs.notifyObservers('SAVE_DRAFT');
        // Attach a subscriber which we will detach right away, since it changes depending on type.
        const unsubcribe = LawDocs.addObserver((event, variables) => {
            if (event === 'MESSAGE') {
                const [message, severity] = variables;
                if (severity === 'error') {
                    setErrorMessage(message);
                    setLoading(false);
                }
            }
            if (event === 'DRAFT_SAVED') {
                // If a redirect is specified, don't stop spinner, just redirect.
                if (type === TYPE_SAVE) {
                    setLoading(false);
                }
                else {
                    if (ga) {
                        ga('send', 'event', 'Document: Exit', location.pathname);
                    }
                    location.href = '/lawdocs/exit';
                }
                unsubcribe();
            }
        });
    };
    return (_jsxs("div", { children: [isAuthenticationModalVisible ? (_jsx(AuthenticationModal, { onClose: () => setAuthenticationModalVisible(false), onCreate: () => save(TYPE_SAVE, true) })) : null, errorMessage && _jsx(Message, { message: errorMessage, isSuccessful: false }), _jsxs("div", Object.assign({ className: 'save-box', role: 'button', tabIndex: 0, onClick: () => save(TYPE_SAVE) }, { children: [isLoading === TYPE_SAVE && _jsx("i", { className: 'fas fa-spinner-third fa-spin' }), (!isLoading || isLoading === TYPE_EXIT) && _jsx("i", { className: 'save-box--icon fa fa-save', "aria-hidden": 'true' })] })), _jsxs("div", Object.assign({ className: 'save-box', role: 'button', tabIndex: 0, onClick: () => save(TYPE_EXIT) }, { children: [isLoading === TYPE_EXIT && _jsx("i", { className: 'fas fa-spinner-third fa-spin' }), (!isLoading || isLoading === TYPE_SAVE) && _jsx("i", { className: 'save-box--icon fa fa-sign-out', "aria-hidden": 'true' }), _jsx("span", Object.assign({ className: 'save-box--text' }, { children: T.translate('document.save.exit') }))] }))] }));
};
LawdocsSaveButton.propTypes = { user: PropTypes.object };
export default LawdocsSaveButton;
